export const LOGOUT = 'auth/LOGOUT'
export const REFRESH_TOKEN_SUCCESS = 'auth/REFRESH_TOKEN_SUCCESS'
export const INTERNAL_SERVER_ERROR = 'auth/INTERNAL_SERVER_ERROR'
export const NETWORK_ERROR = 'auth/NETWORK_ERROR'
export const CLEAR_INTERNAL_SERVER_ERROR = 'auth/CLEAR_INTERNAL_SERVER_ERROR'
export const CLEAR_500_ERROR = 'auth/CLEAR_500_ERROR'
export const SET_CONNECTION = 'auth/SET_CONNECTION'
